import React, {useMemo, useState} from 'react'

import {useMedia} from 'react-use'
import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'

import {NewActionButton} from '@festi/common/components/buttons'
import {useCommonContext} from '@festi/common/contexts/common'
import {gridTheme} from '@festi/common/themes'

import CategoryCard from 'src/components/cards/redesign/CategoryCard'

const SubCategoryContanier = styled.div`
  padding-block: 20px;

  ${media.md`
    padding-block: 40px;
  `}
`

const SubCategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  ${media.sm`
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  `}

  ${media.md`
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
  `}
`

const ViewMoreBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
`

interface SubCategoryListProps {
  categoryId: number
}

export default function SubCategoryList({categoryId}: SubCategoryListProps) {
  const [subCategoriesExpanded, setSubCategoriesExpanded] =
    useState<boolean>(false)

  const {categories} = useCommonContext()
  const subCategories = categories?.filter(
    (category) => category.parent === categoryId,
  )

  const isMobile = useMedia(`(max-width: ${gridTheme.breakpoints.md}px)`, false)

  const subCatsInitialDisplayCount = isMobile ? 6 : 12
  const sliceSubCatsCount = useMemo(
    () =>
      subCategoriesExpanded ? subCategories.length : subCatsInitialDisplayCount,
    [subCategories?.length, subCategoriesExpanded, subCatsInitialDisplayCount],
  )

  if (!subCategories?.length) return null

  return (
    <SubCategoryContanier>
      <SubCategoryGrid>
        {subCategories
          .map((category) => (
            <CategoryCard
              key={category.id}
              category={category}
              slug={category.slug}
            />
          ))
          .slice(0, sliceSubCatsCount)}
      </SubCategoryGrid>

      {subCategories.length > subCatsInitialDisplayCount && (
        <ViewMoreBtnWrapper>
          <NewActionButton
            buttonVariant="subtle"
            onClick={() => setSubCategoriesExpanded(!subCategoriesExpanded)}
          >
            {subCategoriesExpanded
              ? 'Sjá færri vöruflokka'
              : 'Sjá alla vöruflokka'}
          </NewActionButton>
        </ViewMoreBtnWrapper>
      )}
    </SubCategoryContanier>
  )
}
